import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

type RuleNames =
  | 'mainBlock'
  | 'imageBlock'
  | 'infoBlock'
  | 'contentBlock'
  | 'mainInfo'
  | 'secondaryInfo'
  | 'name'
  | 'nameBlock'
  | 'image'
  | 'goalsBlock'
  | 'goal'
  | 'mainCancelledBlock'
  | 'mainInfo2';

const PREFIX = 'Card';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainBlock: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: 240,
        borderRadius: 8,
        padding: '24px 16px',
        background: '#FFFFFF',
        boxShadow: '0px -2px 20px rgba(6, 7, 5, 0.14)',
        cursor: 'pointer',
        marginBottom: '24px',
      },
      mainCancelledBlock: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: 240,
        borderRadius: 8,
        padding: '24px 16px',
        background: '#FFFFFF',
        boxShadow: '0px -2px 20px rgba(6, 7, 5, 0.14)',
        cursor: 'pointer',
        opacity: 0.5,
      },
      cardBlock: {
      },
      imageBlock: {
        position: 'relative',
        height: 88,
        marginBottom: 10,
      },
      image: {
        position: 'relative',
        width: '240px',
        height: '88px',
        borderRadius: '4px',
        objectFit: 'cover',
      },
      goalsBlock: {
        position: 'absolute',
        left: 8,
        bottom: 8,
        maxHeight: '85%',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        gap: 4,
        flexWrap: 'wrap',
      },
      goal: {
        height: 14,
        padding: '4px 8px',
        background: '#E6E6E6',
        borderRadius: 10,
        textAlign: 'center',
        opacity: '0.7',
        fontWeight: 400,
        fontSize: 12,
        color: theme.darkGreen,
      },
      infoBlock: {
        display: 'flex',
        height: 35,
        gap: 16,
        alignItems: 'flex-start',
        marginBottom: 10,
        width: 240,
      },
      contentBlock: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
      },
      mainInfo: {
        fontFamily: theme.helveticaNeueMedium,
        fontSize: 14,
        color: theme.darkGreen,
      },
      mainInfo2: {
        fontFamily: theme.helveticaNeueMedium,
        fontSize: 14,
        color: theme.darkGreen,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '80%',
      },
      secondaryInfo: {
        fontWeight: 400,
        fontSize: 12,
        color: '#999999',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '80%',
      },
      name: {
        fontSize: '20px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        fontFamily: theme.helveticaNeueBold,
        color: theme.darkGreen,
      },
      nameBlock: {
        width: '100%',
      },
    }
  ),
  { name: PREFIX },
);
